import { useEffect, useState, } from 'react';
import { Link, useParams, useHistory, } from 'react-router-dom';
import axios from 'axios';
import htmlParser from 'react-html-parser';

import { globalSettings, isUndNullEmp, languageObjGet, LoadingSection, responseGet, sendMessageCloseCurrentWindowAsync } from '../../helpers/settings';
import { welcomeMessageEmailBodyGet } from '../../controllers/emails/emails';
import Menu from '../main/Menu';
import useAuth from '../../controllers/users/useAuth';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { userModelGet } from '../../models/users/user';

const currentMethod = 'WelcomeMessage';

const { app, labels, messages, } = globalSettings;
const { backend, } = app;

export default function WelcomeMessage({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result = {};
    let dataObj = {};
    const auth = useAuth();
    const { id, } = useParams();
    const history = useHistory();
    const [user, setUser] = useState(userModelGet({}));
    const [htmlCode, setHtmlCode] = useState('');
    //const [showWelcomeMessage, setShowWelcomeMessage] = useState(false);
    const [showLoading, setShowLoading] = useState(true);
    const [showData, setShowData] = useState(false);
    //#endregion variables

    //#region methods
    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let userLocal = userModelGet({});
            //#endregion variables

            setShowLoading(true);
            setShowData(false);

            //#region user get
            dataObj = {
                method: backend?.methods?.getById,
                languageId: languageObj?.id,
                //url: `${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}${backend?.urlNtNr}/${id}`,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}${backend?.urlNtNr}/${id}`,
            }

            result = await axios?.post(
                dataObj?.url,
                dataObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                history.push('/');
                return response;
            }

            userLocal = response?.result || {}
            setUser(userLocal);
            //#endregion user get

            //#region htmlMessage get
            response = welcomeMessageEmailBodyGet({
                userId: userLocal?.id,
                firstName: userLocal?.firstName,
                lastName: userLocal?.lastName,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                history.push('/');
                return response;
            }

            setHtmlCode(response?.result || '');
            //#endregion htmlMessage get

            setShowLoading(false);
            setShowData(true);
        } catch (ex) {
            setShowLoading(false);
            setShowData(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad'
        });
    }, []); //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName='home' process='home' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.welcomeMessage?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    {/* <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li> */}
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.welcomeMessage?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {!showLoading ?
                            <div>
                                {showData ?
                                    <div>
                                        {//!isUndefined(user) && !isNull(user) && !isEmpty(user) && showWelcomeMessage ?
                                            !isUndNullEmp({ data: user?.id, subMethod: currentMethod, })?.result ?
                                                <div>
                                                    {htmlParser(htmlCode)}
                                                    {/* <img alt='appLogo' src={globalSettings?.images?.appLogo} style={styles?.appLogoHome} /> */}
                                                </div>
                                                :
                                                <div></div>
                                        }
                                    </div>
                                    :
                                    <div></div>
                                }
                            </div>
                            :
                            <div className='text-center'
                                style={{ paddingTop: '50px', }}>
                                <LoadingSection alt='loadingSection'
                                    className={globalSettings?.react?.html?.overlay?.textMued}
                                    //className='overlay text-muted'
                                    showText={true}
                                    text={messages?.processing?.[languageObj?.id]}
                                    height={25}
                                    hidden={!showLoading}
                                    languageId={languageObj?.id}
                                    width={25}
                                    subMethod={currentMethod} />
                            </div>
                        }

                        <br />

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

            </div>
        </div>
    );
}